import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { TaxListView } from "./tax-list.view";
import { TaxListDataService } from "./tax-list.data";

export class TaxListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: TaxListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = TaxListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: TaxSummary) {
        this.props.history.push(`/general/taxes/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <TaxListView
            model={this.dataService}
            setBusy={this.props.setBusy} onItemDoubleClicked={this.onItemDoubleClicked} {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/list/tax-list.controller.tsx